import findKey from 'lodash/findKey'
import SETUP_WIZARDS_STEPS, { SETUP_WIZARDS, WIZARD_SECTIONS } from '@/constants/setup-wizards'
import { BUSINESS_FEATURES_STEPS } from '@/constants/business-types'

// eslint-disable-next-line import/prefer-default-export
export function getFirstPendingWizardRoute(isWizardPassed: Function, canAccessWizard: Function = () => true, currentWizard = '') {
  const wizardsKeys = Object.values(SETUP_WIZARDS)
  const defaultPosition = { start: 0, end: wizardsKeys.length }
  let positions = [defaultPosition]

  if (currentWizard) {
    const sectionKey = findKey(WIZARD_SECTIONS, (wizards: any) => wizards.includes(currentWizard)) ?? ''
    const sectionWizards = WIZARD_SECTIONS[sectionKey] ?? []
    const firstSectionWizardIndex = Math.max(wizardsKeys.findIndex((wizard: string) => wizard === sectionWizards?.[0]), 0)
    const lastSectionWizardIndex = Math.max(wizardsKeys.findIndex((wizard: string) => wizard === sectionWizards?.[sectionWizards.length - 1]), 0)

    const currentWizardIndex = Math.max(wizardsKeys.findIndex((wizard: string) => wizard === currentWizard), 0)

    const currentWizardPosition = { start: currentWizardIndex, end: lastSectionWizardIndex + 1 }
    const sectionPosition = { start: firstSectionWizardIndex, end: wizardsKeys.length }

    positions = [currentWizardPosition, sectionPosition, defaultPosition]
  }

  for (let positionIndex = 0; positionIndex < positions.length; positionIndex += 1) {
    const { start, end } = positions[positionIndex]

    for (let keyIndex = start; keyIndex < (end || wizardsKeys.length); keyIndex += 1) {
      const { route } = SETUP_WIZARDS_STEPS[wizardsKeys[keyIndex]] ?? {}
      const canAccess = canAccessWizard(wizardsKeys[keyIndex])

      if (wizardsKeys[keyIndex] !== currentWizard && canAccess && route && !isWizardPassed(wizardsKeys[keyIndex])) {
        return { name: route }
      }
    }
  }
  return null
}

export function hasBusinessTypeHasStep(step: string, isBusinessFeatureEnabled: Function) {
  const features: any = BUSINESS_FEATURES_STEPS?.[step]

  if (!features) return true

  return features.every((feature: any) => isBusinessFeatureEnabled(feature))
}
